/**
 * API сервис для управления AI промптами (только для super-admin)
 */
import { apiClient } from './api';

export const promptsService = {
  /**
   * Получить все промпты
   * @returns {Promise<Array>} Список всех промптов
   */
  async getAllPrompts() {
    console.log('📡 promptsService.getAllPrompts called');
    const data = await apiClient.get('/prompts');
    console.log('📊 Received from API:', data);
    console.log('🔍 Type:', typeof data, 'Is array:', Array.isArray(data));
    return data;  // apiClient.get уже возвращает распарсенные данные
  },

  /**
   * Получить промпт по типу
   * @param {string} promptType - Тип промпта (audio_transcription, text_processing, photo_ocr)
   * @returns {Promise<Object>} Данные промпта
   */
  async getPromptByType(promptType) {
    const response = await apiClient.get(`/prompts/${promptType}`);
    return response.data;
  },

  /**
   * Обновить промпт
   * @param {string} promptType - Тип промпта
   * @param {Object} data - Данные для обновления
   * @param {string} data.custom_prompt - Кастомный промпт
   * @param {boolean} data.use_custom - Использовать кастомный промпт
   * @returns {Promise<Object>} Обновленный промпт
   */
  async updatePrompt(promptType, data) {
    console.log('📡 promptsService.updatePrompt called:', promptType, data);
    const result = await apiClient.put(`/prompts/${promptType}`, data);
    console.log('📊 Update result:', result);
    return result;  // apiClient.put уже возвращает распарсенные данные
  },

  /**
   * Сбросить промпт к дефолтному значению
   * @param {string} promptType - Тип промпта
   * @returns {Promise<Object>} Промпт с дефолтными настройками
   */
  async resetPrompt(promptType) {
    console.log('📡 promptsService.resetPrompt called:', promptType);
    const result = await apiClient.post(`/prompts/${promptType}/reset`);
    console.log('📊 Reset result:', result);
    return result;  // apiClient.post уже возвращает распарсенные данные
  }
};
